import { View } from "react-native";
import PillButton from "src/components/PillButton";
import Touchable from "src/components/Touchable";
import useStyle from "src/hooks/useStyle";
import IconLeft from "src/icons/IconLeft";
import { paddingLarge, paddingMedium } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import { CommentsThreadHeaderHeight } from "../../constants";
import useCommentsThreadStore from "../../hooks/useCommentsThreadStore";

const CommentsThreadHeader = () => {
	const safeArea = useCommentsThreadStore((state) => state.safeArea);
	const onClose = useCommentsThreadStore((state) => state.onClose);
	const onBack = useCommentsThreadStore((state) => state.onBack);
	const title = useCommentsThreadStore((state) => state.title);
	const hasBackButton = !!onBack;
	const { theme } = useStyle();

	return (
		<View
			style={{
				zIndex: 1,
				elevation: 1,
				width: "100%",
				height: CommentsThreadHeaderHeight + safeArea.top,
				alignItems: "center",
				paddingTop: safeArea.top,
				paddingHorizontal: paddingLarge,
				justifyContent: hasBackButton ? "space-between" : "flex-end",
				flexDirection: "row",
			}}
		>
			<View
				style={{
					position: "absolute",
					paddingTop: safeArea.top,
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Text semibold>{title}</Text>
			</View>
			{hasBackButton && (
				<Touchable
					onPress={onBack}
					style={{
						flexDirection: "row",
						alignItems: "center",
						columnGap: paddingMedium,
					}}
				>
					<IconLeft size={14} />
					<Text semibold>All</Text>
				</Touchable>
			)}
			<PillButton onPress={onClose}>Done</PillButton>
		</View>
	);
};
export default CommentsThreadHeader;
